import { Signer } from 'ethers';
import {
  VoteContractDetailsEntity,
  VoteDetailsEntity,
  VoteStatusEntity,
} from '@reyaxyz/common';

export type SignedVote = {
  signature: string;
  deadline: number;
};

export type VoteResult = {
  transactionHash: string | null;
};

export type GetVoteDetailsParams = {
  slug: VoteDetailsEntity['slug'];
};
export type GetVoteDetailsResult = VoteDetailsEntity;

export type GetVoteContractDetailsResult = VoteContractDetailsEntity;

export type VoteParams = {
  slug: VoteDetailsEntity['slug'];
  voted: 'yes' | 'no';
  signer: Signer;
};

export type ExecuteVoteParams = VoteParams & {
  contractAddress: string;
};

export type GetVoteStatusParams = {
  address: string;
  slug: VoteDetailsEntity['slug'];
};
export type GetVoteStatusResult = VoteStatusEntity;
